<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 15:58:11
 * @LastEditors: lau
 * @LastEditTime: 2022-08-23 11:46:30
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 15:30:50
 * @LastEditors: lau
 * @LastEditTime: 2022-08-22 15:33:28
-->
<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-08-22 09:10:08
 * @LastEditors: lau
 * @LastEditTime: 2022-08-22 09:15:38
-->

<!-- 根据根据券模版代码查询券模版信息接口内容 -->
<template>
	<div class="">
		<right-structure :Pdatas='infoData'>
			<pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
			<pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
		</right-structure>
	</div>
</template>

<script>
	import structure from "@/components/commonStructure"

	export default {
		name: '',
		components: {
			'right-structure': structure,
		},
		props: ['commonUrls'],
		data() {
			return {
				requestBody: {
				},
				responseCode: {
					"data": {
						"couponCode":"",
						"fixedStatus":0
					},
					"message": "业务成功",
					"resultCode": 0,
					"status": 1
				},
				infoData: {
					explain: "第三方接入系统请求智慧停车开放平台检查电子券是否可发放",
					t_url: this.commonUrls.test + "checkCouponWhetherSendAvailable",
					p_url: this.commonUrls.prod + "checkCouponWhetherSendAvailable",
					precondition: "无",
					fitSystem: "VEMS传统停车场，云停车场",
					pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
					Q_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [
							{info1: 'couponCode',info2: '是',info3: 'String',info4: '优惠券编码'},
							{info1: 'fixedStatus',info2: '否',info3: 'Integer',info4: '0 非固定券，1 固定券'},

					 ]
					}],
					R_params: [{
						titleName: null,
						tabledata: [{tableHead: '参数名',tdName: 'info1'}, {tableHead: '是否必填',tdName: 'info2'}, {tableHead: '类型',tdName: 'info3'}, {tableHead: '说明',tdName: 'info4'}],
						td: [ 
									{ info1: 'availableStatus', info2: '是', info3: 'Integer', info4: '可发放状态：0 不可发放，1 可发放' },

						]
					}],
					codeStatus: [{
						titleName: null,
						tabledata: [{
							tableHead: '状态码',
							tdName: 'info1'
						}, {
							tableHead: '说明',
							tdName: 'info2'
						}],
						td: [{
							info1: '000110',
							info2: '失败',
						}, {
							info1: '00110000',
							info2: '失败',
						}, {
							info1: '110000',
							info2: '失败',
						}]
					}],
				}
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/checkCouponWhetherSendAvailable.vue